import Api from './Api'

class CultureGrowthPhaseService {
    // Growth Phase endpoints
    getGrowthPhases = () => {
        return Api().get('culture-growth-phase')
    }

    createGrowthPhase = data => {
        return Api().post('culture-growth-phase', {
            phase_type: data.phase_type,
        })
    }

    updateGrowthPhase = data => {
        return Api().put('culture-growth-phase', {
            id: data.id,
            phase_type: data.phase_type,
        })
    }

    deleteGrowthPhase = id => {
        return Api().delete('culture-growth-phase', {
            params: { id },
        })
    }

    // Growth Phase Item endpoints
    getGrowthPhaseItems = growthPhaseId => {
        return Api().get('culture-growth-phase-item', {
            params: { growth_phase_id: growthPhaseId },
        })
    }

    createGrowthPhaseItem = data => {
        return Api().post('culture-growth-phase-item', {
            growth_phase_id: data.growth_phase_id,
            growth_index: data.growth_index,
            name: data.name,
            yearly_active_temperature_sum_minimum: data.yearly_active_temperature_sum_minimum,
            en_name: data.locale?.en_name || '',
            et_name: data.locale?.et_name || '',
            fi_name: data.locale?.fi_name || '',
            lt_name: data.locale?.lt_name || '',
            la_name: data.locale?.la_name || '',
        })
    }

    updateGrowthPhaseItem = data => {
        return Api().put('culture-growth-phase-item', {
            id: data.id,
            growth_phase_id: data.growth_phase_id,
            growth_index: data.growth_index,
            name: data.name,
            yearly_active_temperature_sum_minimum: data.yearly_active_temperature_sum_minimum,
            en_name: data.locale?.en_name || '',
            et_name: data.locale?.et_name || '',
            fi_name: data.locale?.fi_name || '',
            lt_name: data.locale?.lt_name || '',
            la_name: data.locale?.la_name || '',
        })
    }

    deleteGrowthPhaseItem = id => {
        return Api().delete('culture-growth-phase-item', {
            params: { id },
        })
    }
}

export default new CultureGrowthPhaseService()
